import React, { Fragment } from 'react';
import Card from 'react-bootstrap/Card';
import { Link } from 'react-router-dom';
import playBtn from "../../Assets/Images/play-button.png";


const ProductCard = ({ key, data, img, productTitle, bookAuthor }) => {

    return (
        <Fragment>
            <Link to={{ pathname: "/book-detail" }} state={{ data }}>
                <Card className='h-100 border-0 bg-transparent rounded overflow-hidden' key={key}>
                    <div className='rounded position-relative overflow-hidden' style={{ height: "340px" }}>
                        {
                            data?.book_type != "book" ? (
                                <>
                                    <img src={playBtn} className='position-absolute m-3 bottom-0' width={"30px"} alt="" />
                                </>
                            ) : ""
                        }

                        <Card.Img variant="top" height={"100%"} width={"100%"} style={{ objectFit: "cover" }} src={data?.book_img} />
                    </div>
                    <Card.Body className='p-0 pt-3'>
                        <Card.Title className='mb-0'>{data?.title}</Card.Title>
                        <Card.Text className='text-muted'>
                            {data?.author_name}
                        </Card.Text>


                    </Card.Body>
                </Card>
            </Link>
        </Fragment>

    );
}

export default ProductCard